module.exports = __webpack_public_path__ + "img/parc2@2x.cc2bec54.png";